export default __webpack_public_path__ + "static/media/direccion.8572e517.png";